import { api } from './base.service';

export const registerUser = ({ firstName, lastName, email }) => 
  api().post('/user-requests/registration', {
    firstName,
    lastName,
    email
  });

export const verifyRegistrationCode = ({ identificator, code }) => 
  api().post('/user-requests/approve-code', {
    identificator,
    code
  });

export const resendVerificationCode = ({ identificator }) => 
  api().post('/user-requests/resend-code', {
    identificator
  }); 